






























import { Component, Vue } from "vue-property-decorator";
import { deleteTemplate, checkDelete } from "@/services/templates/templateService";

@Component
export default class TemplateDeleteModal extends Vue {
    templateToBeDeleted: string = "";
    templateName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            if (this.templateToBeDeleted !== "") this.confirm();
            else this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
        this.templateToBeDeleted = "";
        this.templateName = "";
    }

    open(templateId: string, name: string) {
        checkDelete(templateId).then(response => {
            console.log(response);
            if (response) {
                this.templateToBeDeleted = templateId;
                this.templateName = name;
                this.$bvModal.show("modal-deleteTemplate");
            } else {
                this.$bvModal.show("modal-deleteTemplateNotAllowed");
            }

            window.addEventListener("keydown", this.handleEnter);
        });
    }

    close() {
        this.$bvModal.hide("modal-deleteTemplateNotAllowed");
    }

    decline() {
        this.$bvModal.hide("modal-deleteTemplate");
        this.templateToBeDeleted = "";
        this.templateName = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteTemplate(this.templateToBeDeleted).then(() => {
            this.$emit("reload");
            this.templateToBeDeleted = "";
            this.templateName = "";
            this.$bvModal.hide("modal-deleteTemplate");
        });
    }
}
